import React from 'react';
import classNames from 'classnames';
import { IFilterOption } from 'core/redux/features/shared/types';

interface ISwitchButtonProps {
  onSelect: (e: React.SyntheticEvent, btn: any) => void;
  selected?: any;
  options: IFilterOption<any>[];
  className?: string;
}

function SwitchButton({
  className,
  options,
  onSelect,
  selected,
}: ISwitchButtonProps) {
  return (
    <div
      className={classNames('buttons has-addons is-switcher', className)}
      id="city-selection"
    >
      {options.map((option, key) => {
        return (
          <a
            key={key}
            style={{ width: `${100 / options.length}%` }}
            href={option.route || '#'}
            onClick={e => onSelect(e, option.id)}
            className={classNames(
              'button',
              selected && selected === option.id && 'is-selected',
              option.icon && 'has-icon',
            )}
          >
            <span className="button-slider-text">
              {option.icon && (
                <span className={`button-slider-icon ${option.icon}`} />
              )}
              {option.label}
            </span>
            <span className="button-slider" />
            {key < options.length - 1 && (
              <span className="button-slider-border" />
            )}
          </a>
        );
      })}
    </div>
  );
}

SwitchButton.defaultProps = {
  active: 0,
};

export default SwitchButton;
